// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__VkwtD","ranges":"BmiRanges_ranges__uyx9O"};